import React, { useCallback } from 'react';
import Scrollbars from 'react-custom-scrollbars';
import styled from 'styled-components';
import { telemetry } from '../../../@vendor/Posthog';
import { LFC } from '../../../Legacy';
import { useResolve } from '../../Container';
import { ParticipantCounter } from '../../canvas/participants/Counter';
import { Box, Colors, remInPx } from './../../../ui';
import { WaitingRoomEntry } from './WaitingRoomEntry';
import { WaitingRoomManager } from './WaitingRoomManager';

const XScrollbars = Scrollbars as any;

const ItemTitle = styled.div`
    padding: .75rem 1rem;
    font-weight: 450;
    border-bottom: solid 1px ${Colors.border};
    color: ${Colors.primaryDark};
`;

const Item = styled.div`
    display: flex;
    align-items: center;    
    padding: .5rem 1rem;
    margin-top: 0.25rem;
    color: ${Colors.text};
`;

const ItemLabel = styled.div`
    margin-left: 0.75rem;
    margin-right: 1.5rem;
    min-width: 15rem;
`;

const ItemName = styled.div``;

const ItemInfo = styled.div`
    font-size: .875rem;
    opacity: 0.6;
`;

const ItemButton = styled.div`
    padding: .5rem .75rem;
    margin-left: .25rem;
    font-weight: 450;
    color: ${Colors.primaryText};
    border-radius: .25rem;
    cursor: pointer;
    user-select: none;

    &:hover {
        background: ${Colors.hover};
    }
    &:active {
        background: ${Colors.active};
    }
`;

const ParticipantApprovalItem: LFC<{ user: WaitingRoomEntry }> = ({ user }) => {
    const waiting = useResolve(WaitingRoomManager);
    const onRespond = useCallback((response: 'allow' | 'refuse') => {
        waiting.respondTo(user.id, response);
        telemetry.emit(`board.${response}`);
    }, [waiting]);
    return <Item key={user.id}>
        <ParticipantCounter key={user.id} info={user} />
        <ItemLabel>
            <ItemName>{user.name}</ItemName>
            <ItemInfo>{user.email.endsWith('guest.metroretro.io') ? 'External Guest' : user.email}</ItemInfo>
        </ItemLabel>
        <ItemButton onClick={() => onRespond('allow')}>Allow</ItemButton>
        <ItemButton onClick={() => onRespond('refuse')}>Deny</ItemButton>
    </Item>;
};

export const ManageWaitingRoomView: LFC<{ knockers: WaitingRoomEntry[] }> = ({ knockers }) => {
    return <Box padding="0 0 .25 0">
        <XScrollbars autoHeight autoHeightMax={remInPx(4 * 8)}>
            {knockers.length <= 1 && <ItemTitle>Someone wants to join the board</ItemTitle>}
            {knockers.length > 1 && <ItemTitle>Several people want to join the board</ItemTitle>}
            {knockers.map(x => <ParticipantApprovalItem key={x.id} user={x} />)}
        </XScrollbars>
    </Box>;
};
